import * as React from 'react';
import { NotificationItemData } from './notification_item_data';
import { getBaseURL } from '../../config/runtime';
import { useState } from 'react';
import Popup from '../popup/Popup';

export function NotificationItem(props: {
  data: NotificationItemData;
  removeTask: (id: string) => void;
}) {
  const { removeTask } = props;
  const { type, id, title, status, message, url } = props.data;

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'SUCCESS': {
        return (
          <svg
            className="h-10 w-10 stroke-green-700"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        );
      }
      case 'FAIL': {
        return (
          <svg
            className="h-10 w-10 stroke-red-700"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            ></path>
          </svg>
        );
      }
      case 'PENDING':
      case 'IN_PROGRESS': {
        return (
          <svg
            className="h-8 w-8 animate-spin stroke-orange-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              strokeWidth="4"
            ></circle>
            <path
              className="fill-orange-400 stroke-transparent opacity-75"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        );
      }
      default: {
      }
    }
  };

  const [showImagePreview, setShowImagePreview] = useState(false);

  return (
    <>
      {showImagePreview ? (
        <Popup
          onClose={() => setShowImagePreview(false)}
          title={`(Preview) ${title}`}
        >
          <div className="">
            <img
              className="w-[800px]"
              onClick={() => setShowImagePreview(false)}
              src={`${getBaseURL()}${url}?width=800`}
            />
          </div>
        </Popup>
      ) : null}

      <div className="border-0 border-b border-solid border-b-slate-200">
        <div className="flex w-full justify-between bg-white py-4">
          {/* Status Icon */}
          <div className="flex w-12 items-center justify-center px-2 text-slate-600">
            {getStatusIcon(status)}
          </div>
          <div className="flex-1 pr-2">
            <header className="mb-1 break-words text-lg">{title}</header>
            {status === 'SUCCESS' ? (
              <a
                className="break-words text-base"
                href={`${getBaseURL()}${url}`}
              >
                {message}
              </a>
            ) : null}

            {status !== 'SUCCESS' ? (
              <div className="text-base text-slate-700">{message}</div>
            ) : null}
          </div>

          <div className="flex w-12 items-center justify-center px-2 text-slate-600">
            {/* Bin icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={(event) => {
                removeTask(id);
                fetch('', {
                  method: 'PUT',
                });
                event.stopPropagation();
              }}
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="h-5 w-6 cursor-pointer text-slate-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
          </div>
        </div>
        {type === 'DOWNLOAD_IMAGE_HIGH_RES' && status === 'SUCCESS' ? (
          <div className="relative bg-white pt-2 pb-6 pl-16">
            <div className="relative w-[200px] text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="pointer-events-none absolute top-2 right-2 h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
                />
              </svg>

              <img
                className="block w-full cursor-pointer rounded-lg"
                onClick={() => setShowImagePreview(true)}
                src={`${getBaseURL()}${url}?width=300`}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
